import React from 'react';
import style from './CenterAlignedCell.module.scss';

type CenterAlignedCellProps = React.PropsWithChildren<{}>;

export const CenterAlignedCell: React.FC<CenterAlignedCellProps> = ({ children }) => {
  return <div className={style.centerAligned}>{children}</div>;
};
